import { memo, useState } from 'react'

import { getQaSelector } from '../../utils/common'
import { TableSkeleton } from '../TableSkeleton'

import { QA_NAME_TABLE_DEFAULT } from './Table.constants'
import { getTableVisibleColumns, getTableWrapperStyles } from './Table.utils'
import { TableComponent } from './TableComponent'

import * as styles from './Table.module.css'

function Table({
  bodyProps,
  columns,
  context,
  headerRowProps,
  isLoading,
  items,
  rowProps,
  skeletonProps,
  skeletonRows,
  ...tableProps
}) {
  const [sideScrollButtonY, setSideScrollButtonY] = useState(0)

  const visibleColumns = getTableVisibleColumns(columns)
  const hasItems = items?.length > 0

  if ((!items || !columns) && !isLoading) {
    return null
  }

  const qaProps = getQaSelector({
    context: QA_NAME_TABLE_DEFAULT,
    def: QA_NAME_TABLE_DEFAULT,
    value: context,
  })

  return (
    <div
      {...qaProps}
      className={styles.tableWrapper}
      style={getTableWrapperStyles(sideScrollButtonY)}
    >
      {isLoading ? (
        <TableSkeleton
          {...skeletonProps}
          inline={!hasItems}
          rows={skeletonRows || (hasItems ? items.length : undefined)}
        />
      ) : null}
      {columns && (!isLoading || hasItems) ? (
        <TableComponent
          {...tableProps}
          bodyProps={bodyProps}
          columns={columns}
          context={context}
          headerRowProps={headerRowProps}
          items={items}
          rowProps={rowProps}
          visibleColumns={visibleColumns}
          onChangeSideScrollButtonY={setSideScrollButtonY}
        />
      ) : null}
    </div>
  )
}

export default memo(Table)
